import { Component, OnInit, Output } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { AppResource } from 'src/app/app.resource';
import { Step } from 'src/app/core/models/step.model';
import { State } from 'src/app/core/state/core.state';

import { BaseComponent } from 'src/app/shared/components/base-component/base-component.component';
import { PopUpInfoVM } from 'src/app/shared/models/components/popupinfoVm';
import { QuestionVM } from 'src/app/shared/models/components/questionVm';

import { EventEmitter } from '@angular/core';
import { lastValueFrom, take } from 'rxjs';
import { PathType } from 'src/app/core/enums/path-type.enum';
import { cloneResumeStep } from 'src/app/core/models/resume-step.model';
import { Stepper } from 'src/app/resources/resource';
import * as fromInfo from '../../../../core/state/info';
import * as fromInsured from '../../../../core/state/insured';
import * as fromSubscriber from '../../../../core/state/subscriber';
import { MemberService } from 'src/app/api/services/member.service';
export interface QuestionEtudiant {
  type: TypeQuestion;
  libelle: string;
  info?: PopUpInfoVM;
  reponse: boolean | string | number | null;
  reponseType: TypeResponse;
  buttonValue1?: string;
  buttonValue2?: string;
  placeholder?: string;
}

export enum TypeResponse {
  boolean = 'boolean',
  string = 'string',
  dropdown = 'dropdown'
}

export enum TypeQuestion {
  duration = 'duration',
  whoToInsure = 'whoToInsure',
  userEmail = 'userEmail',
  emailToInsure = 'emailToInsure',
  signatoryInsurance = 'signatoryInsurance'
}

@Component({
  selector: 'app-info-insured-he',
  styleUrl: './insured.component.scss',
  templateUrl: './insured.component.html'
})
export class InfoInsuredComponent extends BaseComponent implements OnInit {
  @Output() nextStepEvent = new EventEmitter<void>();

  constructor(store: Store<State>, resources: AppResource, memberService: MemberService) {
    super(store, resources);
    this.memberService = memberService;
  }

  memberService: MemberService;
  isEligible: boolean = true;
  displayError: boolean = false;

  substep: number = 1;
  stepNumber: number = 1;

  override step: Step = {
    step: this.resource.header.stepContact,
    stepNumber: this.stepNumber,
    subStep: this.resource.header.subStepSubscriber,
    subStepNumber: this.substep
  };

  contractForMe: boolean | null = null;
  contractForMyChild: boolean | null = null;

  path!: PathType;
  pathType = PathType;
  isUserCurrentSignatoryInsurance: boolean | null = null;

  typeResponse = TypeResponse;
  typeQuestion = TypeQuestion;
  valueDropdownQuestion: { label: string; value: number }[] = [];

  displayButton: boolean = true;
  displayModal: boolean = false;

  questions: QuestionEtudiant[] = [
    {
      type: TypeQuestion.duration,
      libelle: this.resource.question.insuredStudent.duration,
      info: new PopUpInfoVM([this.resource.infobulle.studentDurationInsurance]),
      reponse: null,
      reponseType: TypeResponse.dropdown,
      placeholder: 'Sélectionner une durée'
    },
    {
      type: TypeQuestion.whoToInsure,
      libelle: this.resource.question.insuredStudent.whoToInsure,
      reponse: null,
      reponseType: TypeResponse.boolean, // True => Moi, False => Mon enfant
      buttonValue1: this.resource.question.insuredStudent.myself,
      buttonValue2: this.resource.question.insuredStudent.other
    },
    {
      type: TypeQuestion.emailToInsure,
      libelle: this.resource.question.insuredStudent.emailToInsure,
      reponse: null,
      reponseType: TypeResponse.string,
      placeholder: 'Email'
    },
    {
      type: TypeQuestion.signatoryInsurance,
      libelle: this.resource.question.insuredStudent.signatoryInsurance,
      info: new PopUpInfoVM([this.resource.infobulle.needToBeAdult]),
      reponse: null,
      reponseType: TypeResponse.boolean,
      buttonValue1: this.resource.form.yes,
      buttonValue2: this.resource.form.no
    },
    {
      type: TypeQuestion.userEmail,
      libelle: this.resource.question.insuredStudent.userEmail,
      reponse: null,
      reponseType: TypeResponse.string,
      placeholder: 'Email'
    }
  ];

  formQuestions: FormArray<
    FormGroup<{
      question: FormControl<QuestionVM>;
      info: FormControl<PopUpInfoVM | undefined>;
      answer: FormControl<boolean | string | number | null>;
      answerType: FormControl<string>;
      questionType: FormControl<TypeQuestion>;
      action1: FormControl<string | null>;
      action2: FormControl<string | null>;
      placeholder: FormControl<string>;
    }>
  > = new FormArray<
    FormGroup<{
      question: FormControl<QuestionVM>;
      info: FormControl<PopUpInfoVM | undefined>;
      answer: FormControl<boolean | string | number | null>;
      answerType: FormControl<string>;
      questionType: FormControl<TypeQuestion>;
      action1: FormControl<string | null>;
      action2: FormControl<string | null>;
      placeholder: FormControl<string>;
    }>
  >([]);

  override async ngOnInit() {
    this.updateResumeStepVisibility(true);
    this.initForm();
    this.loadListeners();
    super.ngOnInit();
  }

  initForm() {
    for (let i = 11; i >= 2; i--) {
      if (i === 11) {
        this.valueDropdownQuestion.push({ label: '12 mois et plus', value: 12 });
      } else {
        this.valueDropdownQuestion.push({
          label: `${i + 1} mois`,
          value: i + 1
        });
      }
    }

    const displayForInit = [TypeQuestion.duration];
    this.addQuestionToForm(
      this.questions.filter(i => displayForInit.includes(i.type)).map(i => i.type)
    );
  }

  loadListeners() {
    //  #region listeners
    const switcher = this.formQuestions.controls.find(
      i => i.controls.questionType.value === TypeQuestion.whoToInsure
    );
    switcher?.controls.answer.valueChanges.subscribe(value => {
      if (value) {
        this.contractForMe = true;
        this.contractForMyChild = false;
      } else {
        this.contractForMe = false;
        this.contractForMyChild = true;
      }
      if (!this.displayButton) this.displayButton = true;
      this.handleChangeQuestionTypeForMeOrMyChild();
    });

    const signatoryInsurance = this.formQuestions.controls.find(
      i => i.controls.questionType.value === TypeQuestion.signatoryInsurance
    );
    signatoryInsurance?.controls.answer.valueChanges.subscribe(value => {
      if (value) this.isUserCurrentSignatoryInsurance = true;
      else this.isUserCurrentSignatoryInsurance = false;
    });

    //  #endregion listeners
  }

  loadValidators() {
    this.formQuestions.controls.forEach(item => {
      if (!item.controls.answer.hasValidator(Validators.required)) {
        if (item.controls.answerType.value === TypeResponse.string) {
          // assuming string is always email adress
          item.controls.answer.setValidators([
            Validators.required,
            Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$')
          ]);
        } else {
          item.controls.answer.setValidators(Validators.required);
        }
      }
    });
  }

  handleChangeQuestionTypeForMeOrMyChild() {
    if (this.contractForMe) {
      // Remove many formGroup for that
      const toRemove = [TypeQuestion.emailToInsure];
      let lastindex = this.removeQuestionFromForm(toRemove);
      if (lastindex === -1)
        lastindex =
          this.formQuestions.controls.findIndex(
            i => i.controls.questionType.value === TypeQuestion.whoToInsure
          ) + 1;
      const toAdd = [TypeQuestion.userEmail];
      this.addQuestionToForm(toAdd, lastindex);

      this.store.dispatch(
        fromSubscriber.changeInsuredStatus({
          isTheSameAsInsured: true
        })
      );
    } else if (this.contractForMyChild) {
      const toRemove = [TypeQuestion.userEmail, TypeQuestion.signatoryInsurance];
      this.removeQuestionFromForm(toRemove);

      const toAdd = [TypeQuestion.emailToInsure, TypeQuestion.userEmail];
      this.addQuestionToForm(toAdd);

      this.store.dispatch(
        fromSubscriber.changeInsuredStatus({
          isTheSameAsInsured: false
        })
      );
    }
  }

  addQuestionToForm(toAdd: TypeQuestion[], index: number = -1) {
    this.questions
      .filter(i => toAdd.includes(i.type))
      .forEach(item => {
        const newQuestion = new FormGroup(
          {
            question: new FormControl<QuestionVM>(new QuestionVM(item.libelle)) as FormControl,
            answer: new FormControl<boolean | string | number | null>(item.reponse) as FormControl,
            info: new FormControl<PopUpInfoVM | undefined>(
              item.info ? item.info : undefined
            ) as FormControl,
            answerType: new FormControl<string>(item.reponseType) as FormControl,
            action1: new FormControl<string | null>(item.buttonValue1 ?? null),
            action2: new FormControl<string | null>(item.buttonValue2 ?? null),
            questionType: new FormControl<string>(item.type) as FormControl,
            placeholder: new FormControl<string>(item.placeholder ?? '') as FormControl
          },
          { updateOn: 'change' }
        );

        const alreadyAdded = this.formQuestions.controls.some(
          iii => iii.controls.questionType.value === item.type
        );

        if (!alreadyAdded) {
          if (index > -1) this.formQuestions.insert(index, newQuestion);
          else this.formQuestions.push(newQuestion);
        }
      });
    this.loadValidators();
    this.loadListeners();
  }

  removeQuestionFromForm(toRemove: TypeQuestion[]) {
    let index: number = -1;
    toRemove.forEach(type => {
      index = this.getIndexFromGroup(
        this.formQuestions.controls.find(i => i.controls.questionType.value === type)!
      );
      if (index !== -1) this.formQuestions.removeAt(index);
    });
    return index;
  }

  getIndexFromGroup(group: FormGroup): number {
    return this.formQuestions.controls.findIndex(i => i === group);
  }

  cancel() {
    this.displayModal = false;
  }

  async updateStepper() {
    let stepper = await lastValueFrom(this.store.select(fromInfo.selectStepper).pipe(take(1)));
    let tmpStepper = JSON.parse(JSON.stringify(stepper)) as Partial<Stepper>;

    let title = tmpStepper.devis.titles.find(
      (x: { libelle: string }) => x.libelle == this.resource.stepper.offer
    );

    let subtitleS = title?.subtitles.find(
      (x: { url: string }) => x.url == this.resource.stepper.subscriberStudent
    );

    if (subtitleS) subtitleS.isValid = true;

    let subtitleN = title?.subtitles.find(
      (x: { url: string }) => x.url == this.resource.stepper.rate
    );

    if (subtitleN) subtitleN.isActive = true;

    // this.store.dispatch(fromInfo.updateStepper({ payload: tmpStepper }));
  }

  async updateResumeStep() {
    const resumeStep = await lastValueFrom(
      this.store.select(fromInfo.selectCurrentResumeStep).pipe(take(1))
    );

    const tmpResumeStep = cloneResumeStep(resumeStep);

    let stepResumeStep = tmpResumeStep.steps?.find(
      (x: { id: string }) => x.id == this.resource.resumestep.souscripteur
    );

    let libelle = this.resource.resumestep.souscripteur;

    if (stepResumeStep) {
      stepResumeStep.step = libelle;
    } else {
      tmpResumeStep.steps?.push({
        id: this.resource.resumestep.souscripteur,
        step: libelle,
        url: this.resource.stepper.subscriber,
        isVisible: true
      });
    }
    this.store.dispatch(fromInfo.updateResumeStep({ payload: tmpResumeStep }));
  }

  async switchStep() {
    switch (this.substep) {
      case 1: {
        if (this.displayButton) this.displayButton = false;
        const duration = this.formQuestions.controls.find(
          i => i.controls.questionType.value === TypeQuestion.duration
        )!;

        this.store.dispatch(
          fromInsured.changeDurationWanted({
            duration: Number(duration?.controls.answer.value)
          })
        );

        this.removeQuestionFromForm([TypeQuestion.duration, TypeQuestion.signatoryInsurance]);
        this.resetForm();
        this.addQuestionToForm([TypeQuestion.whoToInsure]);
        this.substep += 1;
        const payload = {
          subStep: this.resource.header.subStepSubscriber,
          step: this.resource.header.stepContact,
          stepNumber: this.stepNumber,
          subStepNumber: this.substep
        } as Partial<Step>;
        this.store.dispatch(fromInfo.updateStep({ payload }));
        break;
      }
      case 2: {
        let email = null;
        if (
          !this.formQuestions.controls.find(
            i => i.controls.questionType.value === TypeQuestion.whoToInsure
          )?.controls.answer.value
        ) {
          const emailToInsure = this.formQuestions.controls.find(
            i => i.controls.questionType.value === TypeQuestion.emailToInsure
          )?.controls.answer.value;
          email = String(emailToInsure);
          this.store.dispatch(
            fromInsured.patchInsured({
              payload: {
                Email: String(emailToInsure)
              }
            })
          );
        }
        const userEmail = this.formQuestions.controls.find(
          i => i.controls.questionType.value === TypeQuestion.userEmail
        )?.controls.answer.value;
        email ??= String(userEmail);
        this.store.dispatch(
          fromSubscriber.patchSubscriber({
            payload: {
              Email: String(userEmail)
            }
          })
        );

        this.memberService.getMemberAge(email, this.contractForMyChild!).subscribe({
          next: async isEligible => {
            this.isEligible = isEligible;
            if (isEligible) {
              await this.updateResumeStep();
              await this.updateStepper();
              this.nextStepEvent.emit();
            }
          },
          error: () => {
            this.displayError = true;
          }
        });

        break;
      }
      default:
        this.substep = 1;
        break;
    }
  }

  IsAgeValidationEnabled(typeQuestion: TypeQuestion): boolean {
    return (
      (typeQuestion === TypeQuestion.userEmail && this.contractForMe!) ||
      (typeQuestion === TypeQuestion.emailToInsure && this.contractForMyChild!)
    );
  }

  resetForm() {
    this.formQuestions.controls.forEach(group => {
      group.reset();
    });
  }
}
